/* eslint-disable import/no-anonymous-default-export */
import {
  GET_Field_VOCABULARY_RECORDS,
  GET_Field_VOCABULARY_SUCCESS,
  GET_Field_VOCABULARY_ERROR,
} from "../actions";

const INIT_STATE = {
  loading: false,
  error: "",
  vocabularyList:[]
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_Field_VOCABULARY_RECORDS:
      return {
        ...state,loading: true, error: "",vocabularyList: null,
      };
    case GET_Field_VOCABULARY_SUCCESS:
      return {...state,loading: false,error: "",vocabularyList: action.payload,
      };
    case GET_Field_VOCABULARY_ERROR:
      let vocabularyList = { ...state.vocabularyList, records: [] };
      vocabularyList.pagination = {
        ...vocabularyList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,loading: false,error: action.payload.message,vocabularyList: vocabularyList,
      };
    default:
      return { ...state };
  }
};
